import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';
import Alert from '@material-ui/lab/Alert';

const baseStyle = {
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 0,
  },
  form: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  row: {
    width: '100%',
    paddingBottom: '1.5rem',
  },
  alert: {
    width: '100%',
  },
  button: {
    minWidth: '9.3rem',
  },
};

const primaryStyle = makeStyles(theme => ({
  ...baseStyle,
  input: {
    backgroundColor: theme.palette.common.paleGrey,
  },
}));

const inverseStyle = makeStyles(theme => ({
  ...baseStyle,
  button: {
    minWidth: '9.3rem',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.common.paleGrey,
    }
  },
}));


const AuthForm = ({children, buttonLabel, buttonAction, disabled, busy, error, cssStyle='primary'}) => {
  const classes = (cssStyle === 'inverse') ? inverseStyle() : primaryStyle();
  return (
    <div className={classes.root}>
      <form className={classes.form} noValidate autoComplete="off">
        {React.Children.map(children, child => child && <div key={child.props.id} className={classes.row}>{child}</div>)}
      </form>
      {error &&
        <Alert severity="error" className={classes.alert}>
          {error}
        </Alert>
      }
      <div className={classes.row}>
        <Button label={buttonLabel} onClick={buttonAction} disabled={disabled} busy={busy} className={classes.button} cssStyle="large"/>
      </div>
    </div>
  );
};

AuthForm.propTypes = {
  children: PropTypes.node.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  busy: PropTypes.bool,
  error: PropTypes.string,
  cssStyle: PropTypes.string,
};

export default AuthForm;
